import { Component } from '@angular/core';

@Component({
	selector: 'app-vessel-form',
	templateUrl: './vessel-form.component.html',
	styleUrl: './vessel-form.component.css'
})
export class VesselFormComponent {

}
